import { z } from "zod";
import { getUnofferedChannels } from "../../../notifications";
import { Constants } from "../../../types/database.types";

/** One kind's choice: each channel on or off, a channel left out stays as it is. */
const notificationChannelChoiceSchema = z.object({
	push: z.boolean().optional(),
	email: z.boolean().optional(),
});

/**
 * The body of `PATCH /users/notification-preferences`: the caller's choices for the kinds named,
 * keyed by `notification_kind`. A kind left out keeps its stored choices. A channel the catalogue
 * does not send the kind on is refused, because no screen offers it.
 */
export const patchNotificationPreferencesSchema = z
	.object({
		preferences: z.partialRecord(
			z.enum(Constants.public.Enums.notificationKind),
			notificationChannelChoiceSchema,
		),
	})
	.superRefine((value, context) => {
		for (const { kind, channel } of getUnofferedChannels(value.preferences)) {
			context.addIssue({
				code: "custom",
				path: ["preferences", kind, channel],
				message: `The kind ${kind} is not sent by ${channel}`,
			});
		}
	});

export type PatchNotificationPreferencesSchema = z.infer<typeof patchNotificationPreferencesSchema>;
